import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ModalService } from 'src/lib/services/utility/modal/modal.service';
import { AssignStudentsModalComponent } from './assign-students-modal.component';

@Injectable({
	providedIn: 'root',
})
export class AssignStudentsModalService {
	constructor(private modalService: ModalService) {}

	public openModal$(
		subtitle: string,
		size: 'sm' | 'lg' | 'xl' | 'max' | string,
		programIds: number[] = null,
	) {
		return new Observable<number[] | null>((o) => {
			const ngbModalOptions: NgbModalOptions = {
				backdrop: 'static',
				size: size,
			};
			const upsertModal = this.modalService.open(
				AssignStudentsModalComponent,
				ngbModalOptions,
				{ subtitle, programIds },
			);

			upsertModal.result
				.then((studentIds: number[] | null) => {
					o.next(studentIds);
					o.complete();
				})
				.catch(() => {
					o.next(null);
					o.complete();
				});
		});
	}
}
